export default __webpack_public_path__ + "static/media/write-begin.412ae889.mp3";